<script setup lang="ts">
import { useProductModal } from '@/composables/useProductModal'

import { MenuProducts } from '@/api/modules/category/types'

type Props = {
  categories: MenuProducts[]
}

defineProps<Props>()

const { openDialogProduct } = useProductModal()
</script>

<template>
  <div class="landing-products">
    <div
      class="landing-products__target landing-products__target--prepend"
      data-category-slug=""
    />

    <section
      v-for="category in categories"
      :id="category.slug"
      :key="category.slug"
      class="landing-products__category"
    >
      <div
        class="landing-products__target landing-products__target--top"
        :data-category-slug="category.slug"
      />

      <h2 class="landing-products__title">
        {{ category.name }}
      </h2>

      <product-list
        :products="category.products"
        @on-open-dialog="openDialogProduct"
      />

      <div
        class="landing-products__target landing-products__target--bottom"
        :data-category-slug="category.slug"
      />
    </section>
  </div>
</template>

<style lang="scss" scoped>
.landing-products {
  position: relative;

  &__title {
    margin: 30px 0 0;
    font-size: 18px;
    font-weight: 800;
    line-height: 24px;
    color: var(--ui-text-primary);

    @include media('>tablet') {
      margin: 30px 0;
      font-size: 28px;
      font-weight: 900;
      line-height: 34px;
    }
  }

  &__category {
    position: relative;
    content-visibility: auto;

    &:first-of-type {
      .landing-products__title {
        margin-top: 0;
      }
    }
  }

  &__target {
    position: absolute;
    right: 0;
    left: 0;
    z-index: -1;
    visibility: hidden;
    height: 50vh;
    pointer-events: none;
    user-select: none;
    opacity: 0;

    &--prepend {
      top: -50vh;
    }

    &--top {
      top: 0;
    }

    &--bottom {
      bottom: 0;
    }
  }
}
</style>
